import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d931f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-range-container" }
const _hoisted_2 = {
  key: 0,
  class: "c-input-label"
}
const _hoisted_3 = { class: "c-input-label-txt" }
const _hoisted_4 = { class: "date-range-picker" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "~", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"0"},
  class: "calendar-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1683597753230",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "3254",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M896 448H128v447.957333l477.738667 0.021334L896 895.957333V448z m0-42.666667V192.042667C896 192 768 192 768 192V149.333333h128.042667A42.666667 42.666667 0 0 1 938.666667 192.042667v703.914666A42.624 42.624 0 0 1 896.064 938.666667H127.936A42.666667 42.666667 0 0 1 85.333333 895.957333V192.042667C85.333333 168.469333 104.256 149.333333 127.957333 149.333333H256v42.666667l-128 0.042667V405.333333h768zM298.666667 85.333333h42.666666v170.666667h-42.666666V85.333333z m384 0h42.666666v170.666667h-42.666666V85.333333zM384 149.333333h256v42.666667H384V149.333333z",
      fill: "#999999",
      "p-id": "3255"
    })
  ])
], -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1683610896580",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4238",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128zM672 627.2c12.8 12.8 12.8 32 0 44.8s-32 12.8-44.8 0L512 556.8l-115.2 115.2c-12.8 12.8-32 12.8-44.8 0s-12.8-32 0-44.8L467.2 512 352 396.8C339.2 384 339.2 364.8 352 352s32-12.8 44.8 0L512 467.2l115.2-115.2c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8L556.8 512 672 627.2z",
    "p-id": "4239",
    fill: "#e6e6e6"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "c-input-error"
}
const _hoisted_13 = {
  key: 1,
  class: "date-wrapper"
}
const _hoisted_14 = { class: "date-body" }
const _hoisted_15 = { class: "calendar" }
const _hoisted_16 = { class: "calendar-header" }
const _hoisted_17 = { style: {"display":"flex"} }
const _hoisted_18 = {
  class: "calendar-title",
  style: {"margin-right":"180px"}
}
const _hoisted_19 = { class: "calendar-title" }
const _hoisted_20 = { style: {"display":"flex"} }
const _hoisted_21 = { class: "calendar-body" }
const _hoisted_22 = { class: "start-calendar" }
const _hoisted_23 = { class: "calendar-weekdays" }
const _hoisted_24 = { class: "calendar-days" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "end-calendar" }
const _hoisted_27 = { class: "calendar-weekdays" }
const _hoisted_28 = { class: "calendar-days" }
const _hoisted_29 = ["onClick"]

import { ref, nextTick, onMounted, watchEffect, onUnmounted, reactive, watch } from 'vue';
import { emitter } from '../../utils/eventBus'
import { formatDate } from '@/utils/help';
interface DateObject {
  date: string;
  day: number;
  month: number;
  year: number;
}
type RulesProp = RullProp[];

interface RullProp {
  required?: boolean
  message: string
}
interface CalendarPickerProps {
  value?: [string?, string?];
  rules?: RulesProp;
  label?: string
}

const __default__ = {
  name: 'CalendarPicker'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    rules: null,
    label: null
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: [string?, string?];
  rules?: RulesProp;
  label?: string
};




const state = reactive({
  message: '',
  error: false,
  required: false,
})
const title = ref('');
const showPicker = ref(false);
const startDate = ref('');
const endDate = ref('');
const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
let leftDays = ref<DateObject[]>([])
let rightDays = ref<DateObject[]>([])
let year = ref(new Date().getFullYear());
let month = ref(new Date().getMonth() + 1);
// get the number of days in a month
const getDaysInMonth = (year: number, month: number): number => {
  return new Date(year, month, 0).getDate();
};
// get the first day of a month
const getFirstDayOfMonth = (year: number, month: number): number => {
  return new Date(year, month - 1, 1).getDay();
};
const createDaysArray = (year, month) => {
  let days: DateObject[] = []
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = getFirstDayOfMonth(year, month);
  const prevMonthDays = getDaysInMonth(year, month - 1);
  for (let i = firstDay; i > 0; i--) {
    // console.log('------')
    const prevMonthDay = prevMonthDays - (i - 1);
    days.push({
      date: `${year}-${fixedZero(month - 1)}-${fixedZero(prevMonthDay)}`,
      day: prevMonthDay,
      month: month - 1,
      year: year
    });
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({
      date: `${year}-${fixedZero(month)}-${fixedZero(i)}`,
      day: i,
      month: month,
      year: year
    });
  }
  const lastDayOfWeek = days.length % 7;
  // console.log(lastDayOfWeek)
  if (lastDayOfWeek !== 0) {
    for (let i = 1; i <= 7 - lastDayOfWeek; i++) {
      days.push({
        date: `${year}-${fixedZero(month + 1)}-${fixedZero(i)}`,
        day: i,
        month: month + 1,
        year: year
      });
    }
  }
  return days
}
// create the days array for the current month
const createLeftDaysArray = (year, month) => {
  // leftDays.value = [];
  // nextTick(() => {
  leftDays.value = createDaysArray(year, month)
  // })
};
const fixedZero = (num: number): string => {
  return num < 10 ? ('0' + num) : ('' + num)
}
const createRightDaysArray = (year, month) => {
  // rightDays.value = [];
  // nextTick(() => {
  rightDays.value = createDaysArray(year, month)
  // })
};
// update the calendDatear title and days array
const update = () => {
  title.value = `${year.value}年${month.value}月`;
  createLeftDaysArray(year.value, month.value);
  createRightDaysArray(year.value, month.value + 1);
};
// select a day
const handleDayClick = (day: DateObject) => {
  // let tempMonth = parseInt(startDate.value.split('-')[1]) || 0
  // // console.log(day.month, tempMonth)
  // if (day.month - tempMonth > 1) {
  //   handleNextMonth()
  // }
  //开始时间和结束时间都为空时
  if (!startDate.value && !endDate.value) {
    startDate.value = day.date
  }//开始时间有了
  else if (startDate.value && compareDate(day.date, startDate.value)) {
    endDate.value = day.date
  }
};
const compareDate = (date1, date2) => {
  let oData1 = new Date(date1).getTime()
  let oData2 = new Date(date2).getTime()
  if (oData1 > oData2) {
    return true
  } else {
    return false
  }
};

const isInLeftRange = (day: DateObject): boolean => {
  if (!startDate.value || !endDate.value) {
    return false;
  }

  return compareDate(day.date, startDate.value) && compareDate(endDate.value, day.date) && day.month == month.value
};
const isInRightRange = (day: DateObject): boolean => {
  if (!startDate.value || !endDate.value) {
    return false;
  }

  return compareDate(day.date, startDate.value) && compareDate(endDate.value, day.date) && day.month == month.value + 1
};
// handle cancel button click
const handleCancel = () => {
  if (startDate.value || endDate.value) {
    startDate.value = '';
    endDate.value = '';
    year.value = new Date().getFullYear()
    month.value = new Date().getMonth() + 1
    if (!showPicker.value) {
      emit('update:value', [startDate.value, endDate.value])
    }
    showPicker.value = false;
  }
};
// handle previous year button click
const handlePrevYear = () => {
  year.value--;
};
// handle next year button click
const handleNextYear = () => {
  year.value++;
};
// handle previous month button click
const handlePrevMonth = () => {
  if (month.value === 1) {
    year.value--;
    month.value = 12;
  } else {
    month.value--;
  }
};
// handle next month button click
const handleNextMonth = () => {
  if (month.value === 12) {
    year.value++;
    month.value = 1;
  } else {
    month.value++;
  }
}
const closePicker = () => {
  showPicker.value = false
}
const validateInput = (): boolean => {
  // 接收从父组件传递过来的验证规则（数组类型）
  if (props.rules) {
    // 调用数组的 every 方法，判断是否符合定义的表单验证规则
    const allPassed = props.rules.every(rule => {
      // 表单是否通过验证的标志
      let passed = true
      // 先将规则的提示信息赋值，如果表单验证失败，则会直接获得该message信息
      // 因为 every 只要有一个错误 就会返回错误，且其他数组不会再进行判断
      state.message = rule.message
      if (rule.required) {
        if (props.value) {
          if (props.value[0] || props.value[1]) {
            passed = true
          } else {
            passed = false
          }
        } else {
          passed = false
        }

        // console.log(props.value)
      }
      // console.log(passed)
      return passed
    })
    // 如果表单验证失败，则 allPassed 状态为 false 但是 state 对象中的 error应为 true
    // 所以 allPassed 取反赋值
    state.error = !allPassed
    // validateInput 方法的返回结果
    return allPassed
  }
  // 如果没有 props.rules 的表单规则 则返回 true
  return true
};
watchEffect(() => {
  if (props.value) {
    startDate.value = props.value[0] || ''
    endDate.value = props.value[1] || ''
    if (props.value[0]) {
      year.value = new Date(props.value[0]).getFullYear()
      month.value = new Date(props.value[0]).getMonth() + 1
    } else {
      year.value = new Date().getFullYear()
      month.value = new Date().getMonth() + 1
    }
  }
})
watchEffect(() => {
  update()
})
watch(showPicker, () => {
  if (!showPicker.value) {
    emit('update:value', [startDate.value, endDate.value])
  }
})
onMounted(() => {
  window.addEventListener('click', closePicker)
  update()
  props.rules?.every(rule => {
    if (rule.required) {
      state.required = true
    }
  })
  emitter.emit("formItemCreated", validateInput)
})
onUnmounted(() => {
  window.removeEventListener('click', closePicker)
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (state.required)
            ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                class: "require-icon",
                icon: "require"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label) + ": ", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "date-input",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showPicker.value = true), ["stop"]))
      }, [
        _createElementVNode("input", {
          type: "text",
          class: "start-date",
          value: startDate.value,
          placeholder: "开始日期"
        }, null, 8, _hoisted_5),
        _hoisted_6,
        _createElementVNode("input", {
          type: "text",
          class: "end-date",
          value: endDate.value,
          placeholder: "结束日期"
        }, null, 8, _hoisted_7),
        _hoisted_8,
        _createElementVNode("span", {
          style: {"font-size":"0"},
          class: "cancel-icon",
          onClick: _withModifiers(handleCancel, ["stop"])
        }, _hoisted_11, 8, _hoisted_9)
      ]),
      (state.error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(state.message), 1))
        : _createCommentVNode("", true)
    ]),
    (showPicker.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "calendar-btn",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handlePrevYear()), ["stop"])),
                    style: {"margin-right":"5px"}
                  }, "<<"),
                  _createElementVNode("div", {
                    class: "calendar-btn",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handlePrevMonth()), ["stop"]))
                  }, "<")
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(year)) + "年" + _toDisplayString(_unref(month)) + "月", 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(year)) + "年" + _toDisplayString(_unref(month) + 1) + "月", 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: "calendar-btn",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleNextMonth()), ["stop"])),
                    style: {"margin-right":"5px"}
                  }, ">"),
                  _createElementVNode("div", {
                    class: "calendar-btn",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleNextYear()), ["stop"]))
                  }, ">>")
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (weekday) => {
                      return _createElementVNode("div", {
                        class: "calendar-weekday",
                        key: weekday
                      }, _toDisplayString(weekday), 1)
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftDays), (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["calendar-day", {
                  'current-month': day.month === _unref(month), 'selected': isInLeftRange(day),
                  'current-select-day': day.date == startDate.value || day.date == endDate.value, 'current-day': day.date == _unref(formatDate)('YYYY-MM-DD')
                }]),
                        key: day.date,
                        onClick: _withModifiers(($event: any) => (handleDayClick(day)), ["stop"])
                      }, _toDisplayString(day.day), 11, _hoisted_25))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (weekday) => {
                      return _createElementVNode("div", {
                        class: "calendar-weekday",
                        key: weekday
                      }, _toDisplayString(weekday), 1)
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightDays), (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["calendar-day", {
                  'current-month': day.month === _unref(month) + 1, 'selected': isInRightRange(day),
                  'current-select-day': day.date == startDate.value || day.date == endDate.value, 'current-day': day.date == _unref(formatDate)('YYYY-MM-DD')
                }]),
                        key: day.date,
                        onClick: _withModifiers(($event: any) => (handleDayClick(day)), ["stop"])
                      }, _toDisplayString(day.day), 11, _hoisted_29))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})